import Model from '../Model'
import moment from "moment";
export default class NonConformanceReport extends Model {
    static async find(id) {
        const data = await Http.get(route('api.v2.external.non-conformance-report', id))
        return this.make(data);
    }

    setAttributes(attributes) {
        super.setAttributes(attributes)
        this.formattedDate = moment(attributes.date).format('DD/MM/YYYY');
        let tokens = [
            this.formattedDate,
        ]
        this.tokens = tokens.join('|').toLowerCase();
    }
}
